import * as React from 'react';
import styled, { css } from 'styled-components';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { space, color, themeGet } from 'styled-system';
import { Span } from '../typography';
import { Plus, Edit, Trash2, Grid } from 'react-feather';
import Loader from './loaders/Loader';
import { theme } from '../theme';

type Props = StyledSystemProps & {
  uploadText?: string;
  onClick?: () => void;
  edit?: boolean;
  top?: boolean;
  noText?: boolean;
  loading?: boolean;
  reorder?: boolean;
  remove?: boolean;
};

export const Overlay = styled.div<Props>`
  ${space};
  ${color};
  /* render css rules conditionally */
  ${({ top, remove }: Props) => {
    if (top || remove) {
      return css`
        top: -60px;
        border-bottom-left-radius: ${themeGet('borderRadius', '#FFF')};
      `;
    }
    return css`
      bottom: -60px;
      border-top-left-radius: ${themeGet('borderRadius', '#FFF')};
    `;
  }}
  right: 0;
  opacity: 0;
  display: flex;
  position: absolute;
  align-items: center;
  pointer-events: none;
  box-sizing: border-box;
  justify-content: center;
  border-top-left-radius: ${themeGet('borderRadius', '#FFF')};
  box-shadow: 0 0px 4px -1px rgba(50, 50, 93, 0.3);
  transition: ${themeGet('transition')};
  &:hover {
    cursor: pointer;
    background-color: ${themeGet('colors.white', '#FFF')};
    transition: ${themeGet('transition')};
  }
`;

const PlusIcon = styled(Plus)<any>`
  width: 20px;
  height: 20px;
  font-size: 40px;
  color: ${themeGet('colors.coal', '#FFF')};
`;

const EditIcon = styled(Edit)<any>`
  width: 20px;
  height: 20px;
  font-size: 40px;
  color: ${themeGet('colors.coal', '#FFF')};
`;

const DeleteIcon = styled(Trash2)<any>`
  width: 20px;
  height: 20px;
  font-size: 40px;
  color: ${themeGet('colors.error', '#FFF')};
`;

const GridIcon = styled(Grid)<any>`
  width: 20px;
  height: 20px;
  font-size: 40px;
  color: ${themeGet('colors.putty', '#FFF')};
`;

const ImageOverlay: React.FC<Props> = ({ uploadText, onClick, edit, top, noText, loading, reorder, remove }) => {
  return (
    <Overlay onClick={onClick} bg="transparentWhite" p={3} top={top}>
      <Span pointer={true} color="coal" mt="2px" mr={1}>
        {uploadText ? uploadText : noText ? undefined : 'ADD PHOTO'}
      </Span>
      {edit ? (
        <EditIcon />
      ) : remove ? (
        <DeleteIcon />
      ) : loading ? (
        <Loader color={theme.colors.putty} />
      ) : reorder ? (
        <GridIcon />
      ) : (
        <PlusIcon />
      )}
    </Overlay>
  );
};

export default ImageOverlay;



// WEBPACK FOOTER //
// ./src/components/ImageOverlay.tsx